// Veřejný vstupní bod BCF integrační vrstvy. UI používá jen BCFClient; ostatní
// exporty jsou pro pokročilé scénáře (vlastní adapter/úložiště/workflow).
import { BCFClient, IMPORT_MODE } from "./api/BCFClient.js";
import { ViewerAdapter } from "./adapters/ViewerAdapter.js";
import { IFCViewerAdapter } from "./adapters/IFCViewerAdapter.js";
import { BCFRepository, MemoryBCFRepository } from "./repositories/BCFRepository.js";
import { IndexedDBBCFRepository } from "./repositories/IndexedDBBCFRepository.js";
import { WorkflowEngine } from "./workflow/WorkflowEngine.js";
import { coordinationWorkflow, ROLES, RULES } from "./workflow/WorkflowDefinition.js";
import { BCFLoader } from "./parser/BCFLoader.js";
import { BCFValidator, SEVERITY } from "./validation/BCFValidator.js";
import { BCFEvents } from "./events/BCFEventBus.js";
import { RESOLUTION } from "./resolver/ComponentResolver.js";

export const BCF_SDK_VERSION = "1.0.0";

export {
  BCFClient, IMPORT_MODE,
  ViewerAdapter, IFCViewerAdapter,
  BCFRepository, MemoryBCFRepository, IndexedDBBCFRepository,
  WorkflowEngine, coordinationWorkflow, ROLES, RULES,
  BCFLoader, BCFValidator, SEVERITY, BCFEvents, RESOLUTION,
};
export default BCFClient;
